// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1RScP","inputWrap":"CustomTip_inputWrap__3AmMQ"};